<template>
    <div class="mobile-search-page">
        <HeaderMobile />
        
        <div class="search-container">
            <!-- 搜索框 -->
            <div class="search-box">
                <el-select v-model="searchType" class="search-type">
                    <el-option label="课程名称" value="courseName"></el-option>
                    <el-option label="讲师名称" value="teacher"></el-option>
                </el-select>
                <el-input v-model="searchKeyword" placeholder="请输入关键词" class="search-input" @keyup.enter.native="handleSearch">
                    <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
                </el-input>
            </div>

            <!-- 搜索结果 -->
            <div v-if="hasSearched">
                <div class="result-stats" v-if="courseList.length > 0">
                    <span>找到 <strong>{{ total }}</strong> 个相关课程</span>
                </div>

                <div class="course-list" v-if="courseList.length > 0">
                    <div class="course-card" v-for="course in courseList" :key="course.id" @click="goCourseDetail(course.id)">
                        <img :src="getImageUrl(course.cover)" :alt="course.name" @error="handleCoverError">
                        <div class="course-info">
                            <h3 class="course-title" v-html="highlightKeyword(course.name)"></h3>
                            <div class="course-meta">
                                <span><i class="el-icon-user"></i><span v-html="highlightKeyword(course.author_name || '')"></span></span>
                                <span v-if="course.view_count"><i class="el-icon-view"></i>{{ course.view_count || 0 }}次</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="pagination-wrap" v-if="courseList.length > 0">
                    <el-pagination background layout="prev, pager, next" :current-page="currentPage" :page-size="pageSize" :total="total" @current-change="handlePageChange" small></el-pagination>
                </div>

                <div class="empty-state" v-else>
                    <i class="el-icon-search"></i>
                    <p>未找到相关课程</p>
                    <el-button type="primary" size="small" @click="clearSearch">重新搜索</el-button>
                </div>
            </div>

            <div class="empty-state" v-else>
                <i class="el-icon-search"></i>
                <p>请输入关键词开始搜索</p>
            </div>
        </div>

        <FooterMobile />
    </div>
</template>

<script>
import HeaderMobile from '@/components/mobile/header.vue';
import FooterMobile from '@/components/mobile/fotter.vue';
import { getByName } from '@/api/home';

export default {
    name: 'MobileSearchPage',
    components: { HeaderMobile, FooterMobile },
    data() {
        return {
            searchType: 'courseName',
            searchKeyword: '',
            hasSearched: false,
            courseList: [],
            currentPage: 1,
            pageSize: 10,
            total: 0
        };
    },
    created() {
        this.loadFromQuery();
    },
    watch: {
        '$route.query': {
            handler() {
                this.loadFromQuery();
            },
            deep: true
        }
    },
    methods: {
        loadFromQuery() {
            const keyword = this.$route.query.keyword;
            const type = this.$route.query.type;
            if (keyword) {
                this.searchKeyword = keyword;
                if (type) this.searchType = type;
                this.fetchData();
            }
        },
        handleSearch() {
            if (!this.searchKeyword.trim()) return this.$message.warning('请输入搜索关键词');
            this.currentPage = 1;
            this.fetchData();
        },
        fetchData() {
            this.hasSearched = true;
            const params = {
                keyword: this.searchKeyword.trim(),
                type: this.searchType === 'courseName' ? 1 : 2,
                page: this.currentPage,
                limit: this.pageSize
            };
            getByName(params).then(res => {
                this.courseList = res.data.list || [];
                this.total = res.data.total || 0;
            }).catch(() => {
                this.$message.error('搜索失败');
                this.courseList = [];
                this.total = 0;
            });
        },
        clearSearch() {
            this.searchKeyword = '';
            this.hasSearched = false;
            this.courseList = [];
            this.currentPage = 1;
            this.total = 0;
        },
        goCourseDetail(id) {
            this.$router.push(`/mobile/course/${id}`);
        },
        highlightKeyword(text) {
            if (!text || !this.searchKeyword) return text;
            const reg = new RegExp(this.searchKeyword, 'gi');
            return text.replace(reg, match => `<span class="keyword-highlight">${match}</span>`);
        },
        getImageUrl(url) {
            if (!url) return require('@/static/imgs/default.jpeg');
            if (typeof url === 'string' && (url.startsWith('http://') || url.startsWith('https://'))) return url;
            return process.env.VUE_APP_STATIC_URL + url;
        },
        handleCoverError(e) {
            e.target.src = require('@/static/imgs/default.jpeg');
        },
        handlePageChange(page) {
            this.currentPage = page;
            this.fetchData();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }
};
</script>

<style scoped>
.mobile-search-page { min-height: 100vh; background: #f5f5f5; padding-bottom: 20px; padding-top: 60px; }
.search-container { padding: 15px; }
.search-box { background: #fff; border-radius: 12px; padding: 15px; margin-bottom: 15px; box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
.search-type { width: 100%; margin-bottom: 10px; }
.search-input { width: 100%; }
.result-stats { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); padding: 12px 15px; border-radius: 12px; margin-bottom: 15px; font-size: 14px; color: #fff; box-shadow: 0 4px 12px rgba(102,126,234,0.3); }
.result-stats strong { color: #fff; font-weight: 600; }
.course-list { display: flex; flex-direction: column; gap: 12px; }
.course-card { background: #fff; border-radius: 12px; padding: 12px; display: flex; gap: 12px; box-shadow: 0 2px 8px rgba(0,0,0,0.06); transition: all 0.3s ease; }
.course-card:active { transform: scale(0.98); }
.course-card img { width: 110px; height: 82px; border-radius: 8px; object-fit: cover; }
.course-info { flex: 1; display: flex; flex-direction: column; justify-content: space-between; }
.course-title { font-size: 15px; font-weight: 500; margin-bottom: 8px; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; line-height: 1.4; color: #333; }
.keyword-highlight { color: #f56c6c; font-weight: 600; background: #fff2f0; padding: 0 2px; border-radius: 2px; }
.course-meta { display: flex; gap: 15px; font-size: 12px; color: #999; }
.course-meta span { display: flex; align-items: center; }
.course-meta i { margin-right: 4px; color: #1890ff; }
.pagination-wrap { display: flex; justify-content: center; margin-top: 20px; padding: 15px; background: #fff; border-radius: 12px; box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
.empty-state { background: #fff; border-radius: 12px; text-align: center; padding: 80px 20px; box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
.empty-state i { font-size: 72px; color: #e0e0e0; margin-bottom: 16px; display: block; }
.empty-state p { font-size: 15px; color: #999; margin-bottom: 20px; }
</style>
